import { defineSlotRecipe } from '@chakra-ui/react';
import { drawerAnatomy } from '@chakra-ui/react/anatomy';

import { drawerContentWidth, drawerSizes, type DrawerSize } from './drawer.kds';

const drawerSizeStyles = (size: DrawerSize) => ({
  content: {
    maxW: drawerContentWidth[size],
  },
});

/** KDS Drawer slot recipe — shares header/footer anatomy with Modal. */
export const drawerSlotRecipe = defineSlotRecipe({
  slots: drawerAnatomy.keys(),
  base: {
    backdrop: {
      zIndex: 'overlay',
    },
    positioner: {
      zIndex: 'overlay',
    },
    content: {
      bg: 'neutral.0',
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      overflow: 'hidden',
    },
    header: {
      px: '8',
      py: '6',
    },
    body: {
      px: '8',
      py: '3',
      flex: '1 1 auto',
      minH: '0',
      overflowY: 'auto',
    },
    footer: {
      px: '8',
      py: '6',
      flexShrink: 0,
    },
    title: {
      textStyle: 'h5.medium',
      color: 'neutral.500',
    },
    description: {
      textStyle: 'default.regular',
      color: 'neutral.350',
    },
    closeTrigger: {
      minW: 'initial',
      position: 'absolute',
      top: '6',
      insetInlineEnd: '8',
    },
  },
  variants: {
    size: Object.fromEntries(drawerSizes.map(size => [size, drawerSizeStyles(size)])) as Record<
      DrawerSize,
      ReturnType<typeof drawerSizeStyles>
    >,
  },
  defaultVariants: {
    size: 'md',
  },
});
